import { setClient } from '~/api/axios-instance';

export default ({ $axios, store, env }) => {
  const URL_LIST = env.API_LIST;
  $axios.onRequest(config => {
    URL_LIST.forEach(val => {
      if (!env.proxy) {
        if (!config.url.includes('/messages')) {
          config.url = config.url.replace(val.url, val.base);
        }
      }
    });
    const accessToken = store.getters['auth/getAccessToken'];
    const deviceId = store.getters['auth/getDeviceId'];
    if (accessToken && deviceId) {
      config.headers.common['authorization'] = `Bearer ${accessToken}`;
      config.headers.common['x-device-ad-id'] = deviceId;
      config.headers.common['bukalapak-identity'] = deviceId;
    }
    return config;
  });

  $axios.onResponseError(async err => {
    const { data, status } = err.response;
    if (status === 304) {
      return Promise.reject(err);
    }

    const responseMessage = data?.errors[0].message || '';
    const checkPhoneNumber =
      responseMessage.includes('Metode OTP tidak ada') ||
      responseMessage.includes('Token OTP berhasil dikirimkan') ||
      responseMessage.includes('Token OTP tidak valid'); // this response is expected to return 401
    if (status === 401 && !checkPhoneNumber) {
      try {
        await store.dispatch('auth/refreshToken');
        const accessToken = store.getters['auth/getAccessToken'];
        err.config.headers.common['authorization'] = `Bearer ${accessToken}`;
      } catch (e) {
        return Promise.reject(e);
      }
      return $axios.request(err.config);
    }
    return Promise.reject(err);
  });
  setClient($axios);
};
